var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlay2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.06243 15.9167C0.887463 15.9167 0.71966 15.8472 0.595938 15.7234C0.472216 15.5997 0.40271 15.4319 0.40271 15.2569V0.74306C0.40273 0.628419 0.432622 0.515763 0.489442 0.416194C0.546261 0.316625 0.628046 0.233581 0.726735 0.175246C0.825424 0.116912 0.93761 0.0853007 1.05224 0.0835291C1.16686 0.0817575 1.27997 0.109886 1.38042 0.165143L14.5749 7.42209C14.6783 7.47904 14.7646 7.56271 14.8246 7.66436C14.8847 7.76601 14.9164 7.88193 14.9164 8C14.9164 8.11808 14.8847 8.234 14.8246 8.33565C14.7646 8.4373 14.6783 8.52097 14.5749 8.57792L1.38042 15.8349C1.28301 15.8885 1.17363 15.9166 1.06243 15.9167Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay2);
export default __webpack_public_path__ + "static/media/play2.81c5df42aac4dd8ae958c06255452ff6.svg";
export { ForwardRef as ReactComponent };